webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = apiGet;
/* unused harmony export apiGetExcel */
/* unused harmony export apiUpload */
/* harmony export (immutable) */ __webpack_exports__["a"] = apiPost;
/* unused harmony export apiPut */
/* unused harmony export apiDelete */
/* harmony export (immutable) */ __webpack_exports__["b"] = notify;
function apiGet(vm, url, params, onSuccess, onError, onFinish) {
  var obj = {
    params: params
  };

  params.empresa = "datacont";
  params.token = localStorage.getItem('token');

  vm.axios.get(url, obj).then(function (response) {
    var data = response.data;
    data.status = +data.status;
    console.log('response:', response);
    if (data.status === -1) {
      // No se ha logueado
      localStorage.setItem('token', '');
      window.location.href = '/';
    } else if (data.status === 0) {
      onError(data);
      if (onFinish) onFinish();
    } else {
      onSuccess(data);
      if (onFinish) onFinish();
    }
  }).catch(function (error) {
    onError(error);
    if (onFinish) onFinish();
  });
}

function apiGetExcel(vm, url, params, onSuccess, onError, onFinish) {
  var obj = {
    responseType: 'arraybuffer',
    params: params
  };

  obj.params.empresa = "datacont";
  obj.params.token = localStorage.getItem('token');

  vm.axios.get(url, obj).then(function (response) {
    var data = response.data;
    onSuccess(data);
    if (onFinish) onFinish();
  }).catch(function (error) {
    onError(error);
    if (onFinish) onFinish();
  });
}

function apiUpload(vm, url, params, onSuccess, onError, onFinish) {
  var obj = params;

  params.empresa = "datacont";
  params.token = localStorage.getItem('token');

  vm.axios.post(url, obj).then(function (response) {
    var data = response.data;
    data.status = +data.status;
    console.log('response:', response);
    if (data.status === -1) {
      // No se ha logueado
      localStorage.setItem('token', '');
      window.location.href = '/';
    } else if (data.status === 0) {
      onError(data);
      if (onFinish) onFinish();
    } else {
      onSuccess(data);
      if (onFinish) onFinish();
    }
  }).catch(function (error) {
    onError(error);
    if (onFinish) onFinish();
  });
}

function apiPost(vm, url, params, onSuccess, onError, onFinish) {
  var obj = params;

  params.empresa = "datacont";
  params.token = localStorage.getItem('token');

  vm.axios.post(url, obj).then(function (response) {
    var data = response.data;
    data.status = +data.status;
    console.log('response:', response);
    if (data.status === -1) {
      // No se ha logueado
      localStorage.setItem('token', '');
      window.location.href = '/';
    } else if (data.status === 0) {
      onError(data);
      if (onFinish) onFinish();
    } else {
      onSuccess(data);
      if (onFinish) onFinish();
    }
  }).catch(function (error) {
    onError(error);
    if (onFinish) onFinish();
  });
}

function apiPut(vm, url, params, onSuccess, onError, onFinish) {
  var obj = params;

  params.empresa = "datacont";
  params.token = localStorage.getItem('token');

  vm.axios.put(url, obj).then(function (response) {
    var data = response.data;
    data.status = +data.status;
    console.log('response:', response);
    if (data.status === -1) {
      // No se ha logueado
      localStorage.setItem('token', '');
      window.location.href = '/';
    } else if (data.status === 0) {
      onError(data);
      if (onFinish) onFinish();
    } else {
      onSuccess(data);
      if (onFinish) onFinish();
    }
  }).catch(function (error) {
    onError(error);
    if (onFinish) onFinish();
  });
}

function apiDelete(vm, url, params, onSuccess, onError, onFinish) {
  var obj = {
    params: params
  };

  params.empresa = "datacont";
  params.token = localStorage.getItem('token');

  vm.axios.delete(url, obj).then(function (response) {
    var data = response.data;
    data.status = +data.status;
    console.log('response:', response);
    if (data.status === -1) {
      // No se ha logueado
      localStorage.setItem('token', '');
      window.location.href = '/';
    } else if (data.status === 0) {
      onError(data);
      if (onFinish) onFinish();
    } else {
      onSuccess(data);
      if (onFinish) onFinish();
    }
  }).catch(function (error) {
    onError(error);
    if (onFinish) onFinish();
  });
}

function notify(vm, type, title, text) {
  vm.$notify({
    title: title,
    text: text,
    position: 'bottom right',
    type: type
  });
}

/***/ }),
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_axios__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_notification__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_View_Responder__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_View_Responder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_View_Responder__);







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_2_axios___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_notification___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__webpack_require__(21));
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.defaults.baseURL = "https://api-helpdesk.datacont.com";

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'responder',
    component: __WEBPACK_IMPORTED_MODULE_5__components_View_Responder___default.a
  }]
}));

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_axios__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_notification__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_View_Login__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_View_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_View_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_View_Registrar__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_View_Registrar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_View_Registrar__);








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_2_axios___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_notification___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.defaults.baseURL = "https://api-helpdesk.datacont.com";

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'registrar',
    component: __WEBPACK_IMPORTED_MODULE_6__components_View_Registrar___default.a
  }, {
    path: '/ingresar',
    name: 'login',
    component: __WEBPACK_IMPORTED_MODULE_5__components_View_Login___default.a
  }]
}));

/***/ }),
/* 18 */,
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(59)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(41),
  /* template */
  __webpack_require__(82),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(56)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(42),
  /* template */
  __webpack_require__(78),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Not_Logged_App__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Not_Logged_App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Not_Logged_App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Admin_App__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Admin_App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Admin_App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router_not_logged__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router_admin__ = __webpack_require__(16);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('twoDecimals', function (value) {
  return value.toFixed(2);
});

/* eslint-disable no-new */
var token = localStorage.getItem('token');

window._ = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a;

if (token) {
  new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_5__router_admin__["a" /* default */],
    template: '<adminApp/>',
    components: { adminApp: __WEBPACK_IMPORTED_MODULE_3__Admin_App___default.a }
  });
} else {
  new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_4__router_not_logged__["a" /* default */],
    template: '<notLoggedApp/>',
    components: { notLoggedApp: __WEBPACK_IMPORTED_MODULE_2__Not_Logged_App___default.a }
  });
}

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Header_Logged_vue__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Header_Logged_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Header_Logged_vue__);
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    HeaderComponent: __WEBPACK_IMPORTED_MODULE_0__components_Header_Logged_vue___default.a
  },
  name: 'adminApp'
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'box-seleccionar-local',
  data: function data() {
    return {
      empresa: {},
      locales: [],
      local: {},
      isLoading: true
    };
  },
  created: function created() {
    this.fetch();
  },

  methods: {
    seleccionar: function seleccionar(o) {
      this.local = o;
      this.$emit('selected', this.local);
    },
    fetch: function fetch() {
      var vm = this;

      var obj = {};
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/libroreclamaciones/local', obj, function (data) {
        vm.isLoading = false;
        console.log('data:', data);
        vm.empresa.ruc = data.empresa.ruc;
        vm.empresa.razonSocial = data.empresa.razonSocial;
        vm.locales = data.lista;
      }, function (error) {
        console.log(error);
        vm.isLoading = false;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Problemas al obtener locales');
      });
    },
    clean: function clean() {
      this.local = {};
    }
  }
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'box-ingresar-datos-consumidor',
  data: function data() {
    return {
      consumidor: {}
    };
  },
  created: function created() {},

  methods: {
    sendData: function sendData() {
      this.$emit('send', this.consumidor);
    },
    clean: function clean() {
      this.consumidor = {};
    }
  }
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'box-identificacion-bien-contratado',
  data: function data() {
    return {
      bien: {
        tipo: '',
        moneda: 'soles',
        monto: '',
        descripcion: ''
      },
      tipos: [{ tipo: 'producto', descripcion: 'Producto', clase: 'fa-print' }, { tipo: 'servicio', descripcion: 'Servicio', clase: 'fa-handshake-o' }],
      monedas: [{ codigo: 'soles', descripcion: 'S/' }, { codigo: 'dolares', descripcion: '$' }]
    };
  },
  created: function created() {},

  methods: {
    sendData: function sendData() {
      this.$emit('send', this.bien);
    },
    seleccionarTipo: function seleccionarTipo(o) {
      this.bien.tipo = o.tipo;
      this.sendData();
    },
    seleccionarMoneda: function seleccionarMoneda(o) {
      this.bien.moneda = o.codigo;
      this.sendData();
    },
    clean: function clean() {
      this.bien = {
        tipo: '',
        moneda: 'soles',
        monto: '',
        descripcion: ''
      };
    }
  }
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'box-detalle-pedido-consumidor',
  data: function data() {
    return {
      detalle: {
        tipo: ''
      },
      tipos: [{ codigo: 'reclamo', descripcion: 'Reclamo' }, { codigo: 'queja', descripcion: 'Queja' }]
    };
  },
  created: function created() {},

  methods: {
    sendData: function sendData() {
      this.$emit('send', this.detalle);
    },
    seleccionarTipo: function seleccionarTipo(o) {
      console.log('o.codigo:', o.codigo);
      this.detalle.tipo = o.codigo;
      this.sendData();
    },
    clean: function clean() {
      this.detalle = {
        tipo: ''
      };
    }
  }
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'lista-reclamaciones',
  data: function data() {
    return {
      isLoading: true,
      lista: [],
      seleccionada: {},
      estado: 'pendientes',
      estados: ['pendientes', 'respondidas', 'todas']
    };
  },
  created: function created() {
    this.fetch();
  },

  watch: {
    estado: function estado(value) {
      return this.fetch();
    }
  },
  methods: {
    seleccionar: function seleccionar(o) {
      this.seleccionada = o;
      this.$emit('selected', o);
    },
    fetch: function fetch() {
      var vm = this;

      var obj = {
        estado: vm.estado
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/libroreclamaciones/pendientes', obj, function (data) {
        vm.isLoading = false;
        console.log('data:', data);
        vm.lista = data.lista;
      }, function (error) {
        console.log(error);
        vm.isLoading = false;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Problemas al obtener reclamaciones');
      });
    },
    verPdf: function verPdf(o) {
      var url = "https://api-helpdesk.datacont.com" + '/libroreclamaciones/pdf?empresa=' + "datacont" + '&preimpreso=' + o.preimpreso + '&dni=' + o.dni;
      console.log('url:', url);
      var link = document.createElement('a');
      link.href = url;
      link.target = '_blank';
      link.click();
    }
  }
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'welcome',
  data: function data() {
    return {
      nombre: localStorage.getItem('nombre'),
      empresa: "datacont",
      empresa_full: "Datacont S.A.C."
    };
  },

  methods: {
    logout: function logout() {
      console.log('hola:');
      localStorage.setItem('token', '');
      localStorage.setItem('username', '');
      localStorage.setItem('nombre', '');
      localStorage.setItem('email', '');
      window.location.href = '/';
    }
  }
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'login',
  data: function data() {
    return {
      username: '',
      password: '',
      errorMessage: '',
      isLoading: false
    };
  },

  methods: {
    login: function login() {
      var vm = this;
      this.isLoading = true;
      this.errorMessage = '';

      var obj = {
        username: this.username,
        password: this.password
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["a" /* apiPost */])(vm, '/libroreclamaciones/login', obj, function (data) {
        localStorage.setItem('token', data.token);
        localStorage.setItem('username', data.username);
        localStorage.setItem('nombre', data.nombre);
        localStorage.setItem('email', data.email);
        window.location.reload(true);
        window.location.href = '/';
      }, function (error) {
        vm.errorMessage = error.message;
        vm.isLoading = false;
      });
    }
  }
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_recaptcha__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Box_1_seleccionar_local_vue__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Box_1_seleccionar_local_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Box_1_seleccionar_local_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Box_2_ingresar_datos_consumidor_vue__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Box_2_ingresar_datos_consumidor_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Box_2_ingresar_datos_consumidor_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Box_3_identificacion_bien_contratado_vue__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Box_3_identificacion_bien_contratado_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Box_3_identificacion_bien_contratado_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Box_4_detalle_pedido_consumidor_vue__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Box_4_detalle_pedido_consumidor_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Box_4_detalle_pedido_consumidor_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_general__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'registrar',
  components: {
    VueRecaptcha: __WEBPACK_IMPORTED_MODULE_0_vue_recaptcha__["a" /* default */],
    BoxSeleccionarLocal: __WEBPACK_IMPORTED_MODULE_1__Box_1_seleccionar_local_vue___default.a,
    BoxIngresarDatosConsumidor: __WEBPACK_IMPORTED_MODULE_2__Box_2_ingresar_datos_consumidor_vue___default.a,
    BoxIdentificacionBienContratado: __WEBPACK_IMPORTED_MODULE_3__Box_3_identificacion_bien_contratado_vue___default.a,
    BoxDetallePedidoConsumidor: __WEBPACK_IMPORTED_MODULE_4__Box_4_detalle_pedido_consumidor_vue___default.a
  },
  data: function data() {
    return {
      local: {},
      consumidor: {},
      bien: {},
      detalle: {},
      isSending: false,
      requestRoute: '',
      verifyRecaptcha: '',
      sitekey: 'fer',
      logo: '/static/logo.png'
      // local: {
      //   'codigo': 1,
      //   'descripcion': 'Halcones',
      //   'direccion': 'Av. Halcones 445 Surquillo Lima'
      // },
      // consumidor: {
      //   'dni': '71407846',
      //   'nombre': 'Fernando Benavides',
      //   'email': 'fbenavides@datacont.com',
      //   'direccion': 'Jr. Cipriano Rivas 546 San Juan de Miraflores',
      //   'telefono': '988880026',
      //   'nombrePadre': 'Carola'
      // },
      // bien: {
      //   'tipo': 'producto',
      //   'moneda': 'soles',
      //   'monto': '1000',
      //   'descripcion': 'Scanner DR300'
      // },
      // detalle : {
      //   'tipo': 'reclamo',
      //   'descripcion': 'Cuando Scannea no funciona\nPero ellos dicen que es mi culpa por haberle echado agua\npero en ningun momento en el manual dice que no debo echarle agua, fue un accidente',
      //   'pedido': 'Que me den un nuevo Scanner sin costo adicional'
      // }
    };
  },
  created: function created() {
    this.requestRoute = "https://api-helpdesk.datacont.com";
    this.sitekey = "6LfMNkkUAAAAAExvYIVMFtoGPfIARl42hQlKfJKd";
  },

  methods: {
    asignarLocal: function asignarLocal(o) {
      this.local = o;
    },
    asignarConsumidor: function asignarConsumidor(o) {
      this.consumidor = o;
    },
    asignarBien: function asignarBien(o) {
      this.bien = o;
    },
    asignarDetalle: function asignarDetalle(o) {
      this.detalle = o;
    },
    send: function send() {
      var vm = this;
      this.isSending = true;
      this.requestRoute = "https://api-helpdesk.datacont.com";
      var obj = {
        local: vm.local,
        consumidor: vm.consumidor,
        bien: vm.bien,
        detalle: vm.detalle
      };

      var textoError = this.validar(vm, obj);
      if (textoError) {
        vm.isSending = false;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_general__["b" /* notify */])(vm, 'error', 'Error', textoError);
        return;
      }
      // vm.notify('success', 'Éxito', 'Su reclamo fue enviado correctamente')
      // return
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_general__["a" /* apiPost */])(vm, '/libroreclamaciones', obj, function (data) {
        vm.isSending = false;
        vm.clean();
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_general__["b" /* notify */])(vm, 'success', 'Éxito', 'Su reclamo fue enviado correctamente');
        var url = vm.requestRoute + '/libroreclamaciones/pdf?empresa=' + "datacont" + '&preimpreso=' + data.preimpreso + '&dni=' + data.dni;
        console.log('url:', url);
        var link = document.createElement('a');
        link.href = url;
        link.target = '_blank';
        link.click();
      }, function (error) {
        console.log(error);
        vm.isSending = false;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Su reclamo no pudo ser enviado');
      });
    },
    validar: function validar(vm, obj) {
      // Validamos que el captcha haya sido presionado
      if (!vm.verifyRecaptcha) {
        return 'Por favor de click al reCAPTCHA ';
      }

      // Validamos que haya seleccionado un local
      if (!(obj.local && obj.local.codigo)) {
        return 'Por favor seleccione el local de la empresa donde se encuentra';
      }

      // Validamos los datos del consumidor
      if (obj.consumidor) {
        if (!obj.consumidor.dni) return 'Por favor ingrese su DNI';
        if (!obj.consumidor.nombre) return 'Por favor ingrese su nombre completo';
        if (!obj.consumidor.email) return 'Por favor ingrese su email';
        if (!obj.consumidor.direccion) return 'Por favor ingrese su dirección';
        if (!obj.consumidor.telefono) return 'Por favor ingrese su teléfono';
      } else return 'Por favor ingrese los datos del consumidor';

      // Validamos los datos del bien contratado
      if (obj.bien) {
        if (!obj.bien.tipo) return 'Por favor seleccione un tipo de bien contratado';
        if (!obj.bien.monto) return 'Por favor ingrese un monto del bien contratado';
        if (!obj.bien.moneda) return 'Por favor seleccione una moneda para el monto del bien contratado';
        if (!obj.bien.descripcion) return 'Por favor ingrese una explicación acerca del ' + obj.bien.tipo + ' contratado';
      } else return 'Por favor ingrese los datos del bien contratado';

      // Validamos los datos del detalle de reclamacion
      if (obj.detalle) {
        if (!obj.detalle.tipo) return 'Por favor seleccione un tipo de reclamación';
        if (!obj.detalle.descripcion) return 'Por favor detalle su reclamo';
        if (!obj.detalle.pedido) return 'Por favor ingrese su pedido para ayudarnos a mejorar';
      } else return 'Por favor ingrese los datos del detalle de la reclamacion';

      return '';
    },

    onVerify: function onVerify(response) {
      console.log('Verify: ' + response);
      this.verifyRecaptcha = response;
    },
    onExpired: function onExpired() {
      console.log('Expired');
      this.verifyRecaptcha = '';
    },
    resetRecaptcha: function resetRecaptcha() {
      this.$refs.recaptcha.reset(); // Direct call reset method
      this.verifyRecaptcha = '';
    },
    clean: function clean() {
      this.local = {};
      this.consumidor = {};
      this.bien = {};
      this.detalle = {};
      this.$refs.local.clean();
      this.$refs.consumidor.clean();
      this.$refs.bien.clean();
      this.$refs.detalle.clean();
    }
  }
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Component_lista_reclamaciones_vue__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Component_lista_reclamaciones_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Component_lista_reclamaciones_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_general__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'responder',
  components: {
    ListaReclamaciones: __WEBPACK_IMPORTED_MODULE_0__Component_lista_reclamaciones_vue___default.a
  },
  data: function data() {
    return {
      preimpreso: '',
      dni: '',
      respuesta: '',
      isSending: false
    };
  },
  created: function created() {},

  methods: {
    seleccionarReclamacion: function seleccionarReclamacion(o) {
      console.log('o:', o);
      this.preimpreso = o.preimpreso;
      this.dni = o.dni;
    },
    enviarRespuesta: function enviarRespuesta() {
      var vm = this;
      vm.isSending = true;
      var obj = {
        preimpreso: vm.preimpreso,
        respuesta: vm.respuesta
      };

      if (!obj.respuesta) {
        vm.isSending = false;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Por favor ingrese una respuesta');
        return;
      }
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["a" /* apiPost */])(vm, '/libroreclamaciones/respuesta', obj, function (data) {
        vm.isSending = false;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'success', 'Éxito', 'La reclamación fue respondida exitosamente');
        var url = "https://api-helpdesk.datacont.com" + '/libroreclamaciones/pdf?empresa=' + "datacont" + '&preimpreso=' + vm.preimpreso + '&dni=' + vm.dni;
        console.log('url:', url);
        var link = document.createElement('a');
        link.href = url;
        link.target = '_blank';
        link.click();
        vm.preimpreso = '';
        vm.dni = '';
        vm.respuesta = '';
        vm.$refs.lista.fetch(); // Direct call fetch method
      }, function (error) {
        console.log(error);
        vm.isSending = false;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Su respuesta no pudo ser enviada');
      });
    }
  }
});

/***/ }),
/* 52 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 53 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 54 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 55 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 56 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 57 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 58 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 59 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 60 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 61 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(61)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(43),
  /* template */
  __webpack_require__(84),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(44),
  /* template */
  __webpack_require__(81),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(54)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(45),
  /* template */
  __webpack_require__(76),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-014db368",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(60)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(46),
  /* template */
  __webpack_require__(83),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-975780ac",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(55)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(47),
  /* template */
  __webpack_require__(77),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0d89af84",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(52)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(48),
  /* template */
  __webpack_require__(74),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-00d7fec0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(53)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(49),
  /* template */
  __webpack_require__(75),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-00ff8053",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(57)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(50),
  /* template */
  __webpack_require__(79),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1bef4ad7",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(58)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(51),
  /* template */
  __webpack_require__(80),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-268d1f6c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 74 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-bold app-navbar"
  }, [_c('div', {
    staticClass: "hero-head"
  }, [_c('nav', {
    staticClass: "nav"
  }, [_c('div', {
    staticClass: "nav-left"
  }, [_c('strong', [_vm._v("Bienvenido:")]), _c('span', [_vm._v(_vm._s(_vm.nombre))])]), _c('div', {
    staticClass: "nav-center"
  }, [_c('a', {
    staticClass: "nav-item hero-brand",
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/logo.png",
      "alt": _vm.empresa_full
    }
  })])]), _c('div', {
    staticClass: "nav-right is-flex"
  }, [_c('a', {
    staticClass: "nav-item",
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("Salir")])])])])])
},staticRenderFns: []}

/***/ }),
/* 75 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "half-width margin-auto"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Ingrese sus credenciales")]), _c('div', {
    staticClass: "field"
  }, [_c('p', {
    staticClass: "control has-icons-left has-icons-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Usuario"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  }), _vm._m(1)])]), _c('div', {
    staticClass: "field"
  }, [_c('p', {
    staticClass: "control has-icons-left"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "input",
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._m(2)])]), _c('div', {
    staticClass: "field"
  }, [_c('p', {
    staticClass: "control has-text-centered"
  }, [_c('button', {
    staticClass: "button is-empresa",
    class: {
      'is-loading': _vm.isLoading
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("Ingresar")])])]), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.errorMessage) ? _c('article', {
    staticClass: "message is-danger"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_c('strong', [_vm._v(_vm._s(_vm.errorMessage))])])]) : _vm._e()])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "/static/logo.png",
      "alt": "logo"
    }
  }), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("Admnistrador de libro de reclamaciones")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small is-left"
  }, [_c('i', {
    staticClass: "fa fa-user"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small is-left"
  }, [_c('i', {
    staticClass: "fa fa-lock"
  })])
}]}

/***/ }),
/* 76 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _c('div', {
    key: "tipo-empresa",
    staticClass: "tipo-empresa-container"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Seleccione el tipo de bien contratado")]), _c('div', {
    staticClass: "select-box"
  }, _vm._l((_vm.tipos), function(o) {
    return _c('div', {
      staticClass: "option bd-color-empresa",
      class: {
        'bg-empresa': _vm.bien.tipo === o.tipo
      },
      on: {
        "click": function($event) {
          _vm.seleccionarTipo(o)
        }
      }
    }, [_c('i', {
      staticClass: "fa",
      class: o.clase
    }), _c('span', [_vm._v(_vm._s(o.descripcion))])])
  })), _c('div', [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Monto reclamado")]), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bien.monto),
      expression: "bien.monto"
    }],
    staticClass: "input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.bien.monto)
    },
    on: {
      "blur": function($event) {
        _vm.sendData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.bien, "monto", $event.target.value)
      }
    }
  }), _vm._l((_vm.monedas), function(o) {
    return _c('div', {
      staticClass: "little-option bd-color-empresa",
      class: {
        'bg-empresa': _vm.bien.moneda === o.codigo
      },
      on: {
        "click": function($event) {
          _vm.seleccionarMoneda(o)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(o.descripcion))])])
  })], 2)]), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Descripción")]), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bien.descripcion),
      expression: "bien.descripcion"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.bien.descripcion)
    },
    on: {
      "blur": _vm.sendData,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.bien, "descripcion", $event.target.value)
      }
    }
  })])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "header"
  }, [_c('h2', [_vm._v("3. Identificación de bien contratado")]), _c('p', [_c('span', [_vm._v("Por favor ingrese los datos del producto o servicio que contrató con nosotros")])]), _c('hr')])
}]}

/***/ }),
/* 77 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contenedor-lista"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Lista de reclamaciones")]), _c('div', {
    staticClass: "filtro-estados"
  }, _vm._l((_vm.estados), function(o) {
    return _c('div', {
      staticClass: "option",
      class: {
        'fc-empresa': o === _vm.estado, 'selected': o === _vm.estado
      },
      on: {
        "click": function($event) {
          _vm.estado = o
        }
      }
    }, [_vm._v(_vm._s(o))])
  })), (_vm.lista.length !== 0) ? _c('table', {
    staticClass: "table is-striped is-bordered"
  }, [_vm._m(0), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.lista), function(o) {
    return _c('tr', {
      key: o.preimpreso,
      staticClass: "row-table"
    }, [_c('td', [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(o.preimpreso))])]), _c('td', [_c('span', [_vm._v(_vm._s(o.descripcionLocal))]), _c('br'), _c('span', {
      staticClass: "small"
    }, [_vm._v(_vm._s(o.direccionLocal))])]), _c('td', [_c('span', [_vm._v(_vm._s(o.nombre))]), _c('br'), _c('span', {
      staticClass: "small"
    }, [_vm._v(_vm._s(o.email))]), _c('br'), _c('span', {
      staticClass: "small"
    }, [_vm._v(_vm._s(o.telefono))])]), _c('td', [_vm._v(_vm._s(o.fecha))]), _c('td', {
      staticClass: "center td-acciones"
    }, [_c('button', {
      staticClass: "button bd-color-empresa fc-empresa",
      on: {
        "click": function($event) {
          _vm.verPdf(o)
        }
      }
    }, [_vm._v("Ver detalles")]), (o.estado === 1) ? _c('button', {
      staticClass: "button is-empresa button-responder",
      on: {
        "click": function($event) {
          _vm.$emit('selected', o)
        }
      }
    }, [_vm._v("Responder")]) : _vm._e()])])
  }))]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Numero")]), _c('th', [_vm._v("Local")]), _c('th', [_vm._v("Cliente")]), _c('th', [_vm._v("Fecha")]), _c('th', [_vm._v("Acciones")])])
}]}

/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "client-app",
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view')], 1), _c('notifications')], 1)
},staticRenderFns: []}

/***/ }),
/* 79 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contenedor"
  }, [_c('header', [_vm._m(0), _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": _vm.logo
    }
  })]), _c('div', {
    key: "accion",
    staticClass: "section"
  }, [_c('div', {
    staticClass: "boton-enviar"
  }, [_c('a', {
    staticClass: "button is-empresa",
    class: {
      'is-loading': _vm.isSending
    },
    on: {
      "click": _vm.send
    }
  }, [_vm._m(1), _c('span', [_vm._v("Enviar reclamo")])])])])]), _c('section', {
    staticClass: "body"
  }, [_c('transition-group', {
    staticClass: "contenedor-transition contenedor-sections",
    attrs: {
      "name": "fade-smooth",
      "tag": "div"
    }
  }, [_c('div', {
    key: "seleccionar-local",
    staticClass: "section box"
  }, [_c('box-seleccionar-local', {
    ref: "local",
    on: {
      "selected": _vm.asignarLocal
    }
  })], 1), _c('div', {
    key: "ingresar-datos-consumidor",
    staticClass: "section box"
  }, [_c('box-ingresar-datos-consumidor', {
    ref: "consumidor",
    on: {
      "send": _vm.asignarConsumidor
    }
  })], 1), _c('div', {
    key: "identificacion-bien-contratado",
    staticClass: "section box"
  }, [_c('box-identificacion-bien-contratado', {
    ref: "bien",
    on: {
      "send": _vm.asignarBien
    }
  })], 1), _c('div', {
    key: "detalle-pedido-consumidor",
    staticClass: "section box"
  }, [_c('box-detalle-pedido-consumidor', {
    ref: "detalle",
    on: {
      "send": _vm.asignarDetalle
    }
  })], 1), _c('div', {
    key: "recaptcha"
  }, [_c('vue-recaptcha', {
    ref: "recaptcha",
    staticClass: "recaptcha-container",
    attrs: {
      "sitekey": _vm.sitekey
    },
    on: {
      "verify": _vm.onVerify,
      "expired": _vm.onExpired
    }
  })], 1), _c('div', {
    key: "accion",
    staticClass: "section"
  }, [_c('div', {
    staticClass: "boton-enviar"
  }, [_c('a', {
    staticClass: "button is-empresa",
    class: {
      'is-loading': _vm.isSending
    },
    on: {
      "click": _vm.send
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-send-o"
  })]), _c('span', [_vm._v("Enviar reclamo")])])])])])], 1), _c('notifications')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "information"
  }, [_c('img', {
    attrs: {
      "src": "/static/libro-reclamaciones.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-send-o"
  })])
}]}

/***/ }),
/* 80 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition-group', {
    staticClass: "fondo",
    attrs: {
      "name": "fade-smooth"
    }
  }, [_c('lista-reclamaciones', {
    key: "lista",
    ref: "lista",
    staticClass: "lista",
    on: {
      "selected": _vm.seleccionarReclamacion
    }
  }), (_vm.preimpreso) ? _c('div', {
    key: "respuesta",
    staticClass: "respuesta"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('p', [_c('span', [_vm._v("Seleccionado ")]), _c('strong', [_vm._v(_vm._s(_vm.preimpreso))])])]), _c('div', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.preimpreso = ''
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])])]), _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(" Respuesta a la reclamación")]), _c('div', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.respuesta),
      expression: "respuesta"
    }],
    staticClass: "textarea",
    attrs: {
      "rows": "5",
      "placeholder": "Ingrese la respuesta que quiere dar a la reclamación"
    },
    domProps: {
      "value": (_vm.respuesta)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.respuesta = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "acciones"
  }, [_c('button', {
    staticClass: "button is-empresa button-responder",
    class: {
      'is-loading': _vm.isSending
    },
    on: {
      "click": _vm.enviarRespuesta
    }
  }, [_vm._v("Enviar respuesta")]), _c('button', {
    staticClass: "button bd-color-empresa fc-empresa",
    on: {
      "click": function($event) {
        _vm.preimpreso = ''
      }
    }
  }, [_vm._v("Cancelar")])])])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _c('div', [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Documento de identidad")]), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.consumidor.dni),
      expression: "consumidor.dni"
    }],
    staticClass: "input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.consumidor.dni)
    },
    on: {
      "blur": _vm.sendData,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.consumidor, "dni", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Nombre")]), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.consumidor.nombre),
      expression: "consumidor.nombre"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.consumidor.nombre)
    },
    on: {
      "blur": _vm.sendData,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.consumidor, "nombre", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Correo electrónico")]), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.consumidor.email),
      expression: "consumidor.email"
    }],
    staticClass: "input",
    attrs: {
      "type": "email"
    },
    domProps: {
      "value": (_vm.consumidor.email)
    },
    on: {
      "blur": _vm.sendData,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.consumidor, "email", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Domicilio")]), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.consumidor.direccion),
      expression: "consumidor.direccion"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.consumidor.direccion)
    },
    on: {
      "blur": _vm.sendData,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.consumidor, "direccion", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Teléfono")]), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.consumidor.telefono),
      expression: "consumidor.telefono"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.consumidor.telefono)
    },
    on: {
      "blur": _vm.sendData,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.consumidor, "telefono", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Nombre del padre o madre (Si es menor de edad)")]), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.consumidor.nombrePadre),
      expression: "consumidor.nombrePadre"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.consumidor.nombrePadre)
    },
    on: {
      "blur": _vm.sendData,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.consumidor, "nombrePadre", $event.target.value)
      }
    }
  })])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "header"
  }, [_c('h2', [_vm._v("2. Datos del consumidor")]), _c('p', [_c('span', [_vm._v("Por favor ingrese sus datos, son obligatorios para poder hacer la reclamación")])]), _c('hr')])
}]}

/***/ }),
/* 82 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('header-component'), _c('div', {
    staticClass: "contenedor"
  }, [_c('div', {
    staticClass: "container is-fluid is-marginless min-height-full"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view')], 1)], 1)]), _c('notifications')], 1)
},staticRenderFns: []}

/***/ }),
/* 83 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _c('transition-group', {
    staticClass: "contenedor-transition",
    attrs: {
      "name": "fade-smooth",
      "tag": "div",
      "mode": "out-in"
    }
  }, [_c('div', {
    key: "tipo-empresa",
    staticClass: "tipo-empresa-container"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Seleccione el tipo de reclamación")]), _c('div', {
    staticClass: "select-box"
  }, _vm._l((_vm.tipos), function(o) {
    return _c('div', {
      staticClass: "option bd-color-empresa",
      class: {
        'bg-empresa': _vm.detalle.tipo === o.codigo
      },
      on: {
        "click": function($event) {
          _vm.seleccionarTipo(o)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(o.descripcion))])])
  }))]), (_vm.detalle.tipo === 'queja') ? _c('div', {
    key: "queja-description",
    staticClass: "description-box message is-info"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_c('p', [_vm._v("Una queja es la disconformidad no relacionada a los productos o servicios; ")]), _c('p', [_vm._v("o, malestar o descontento respecto a la atención al público.")])])]) : _vm._e(), (_vm.detalle.tipo === 'reclamo') ? _c('div', {
    key: "reclamo-description",
    staticClass: "description-box message is-info"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_c('p', [_vm._v("Una reclamo es la disconformidad relacionada a los productos o servicios")])])]) : _vm._e(), _c('div', {
    key: "datos",
    staticClass: "datos-persona-natural"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(" Detalle de reclamación")]), _c('div', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detalle.descripcion),
      expression: "detalle.descripcion"
    }],
    staticClass: "textarea",
    attrs: {
      "rows": "5"
    },
    domProps: {
      "value": (_vm.detalle.descripcion)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detalle, "descripcion", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(" Pedido")]), _c('div', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detalle.pedido),
      expression: "detalle.pedido"
    }],
    staticClass: "textarea",
    attrs: {
      "rows": "5"
    },
    domProps: {
      "value": (_vm.detalle.pedido)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detalle, "pedido", $event.target.value)
      }
    }
  })])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "header"
  }, [_c('h2', [_vm._v("4. Detalle de la reclamación y pedido del consumidor")]), _c('p', [_c('span', [_vm._v("Por favor detalle lo sucedido y lo que espera de nosotros para solucionarlo")])]), _c('hr')])
}]}

/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _c('transition-group', {
    staticClass: "contenedor-transition",
    attrs: {
      "name": "fade-smooth",
      "tag": "div"
    }
  }, [_c('div', {
    key: "select-box",
    staticClass: "select-box"
  }, _vm._l((_vm.locales), function(o) {
    return _c('div', {
      staticClass: "option bd-color-empresa",
      class: {
        'bg-empresa': o.codigo === _vm.local.codigo
      },
      on: {
        "click": function($event) {
          _vm.seleccionar(o)
        }
      }
    }, [_c('span', {
      staticClass: "descripcion"
    }, [_vm._v(_vm._s(o.descripcion))])])
  })), (_vm.local && _vm.local.codigo) ? _c('div', {
    key: "description-box",
    staticClass: "description-box message is-info"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_c('div', [_c('strong', [_vm._v("RUC")]), _c('span', {
    staticClass: "value"
  }, [_vm._v(": " + _vm._s(_vm.empresa.ruc))])]), _c('div', [_c('strong', [_vm._v("Razon social")]), _c('span', {
    staticClass: "value"
  }, [_vm._v(": " + _vm._s(_vm.empresa.razonSocial))])]), _c('div', [_c('strong', [_vm._v("Dirección del local")]), _c('span', {
    staticClass: "value"
  }, [_vm._v(": " + _vm._s(_vm.local.direccion))])])])]) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "header"
  }, [_c('h2', [_vm._v("1. Seleccione el local")]), _c('p', [_c('span', [_vm._v("Por favor seleccione el local en el que se encuentra y desea hacer la reclamación")])]), _c('hr')])
}]}

/***/ })
],[40]);


// WEBPACK FOOTER //
// static/js/app.8f174f2cf9df11c36510.js